import {HEAT_INDEX, HUMIDEX} from '../../Units';
import australianFormula from './australianFormula';
import heatIndex from './heatIndex';
import humidex from './humidex';

export default (
  feelLike: 0 | 1 | 2,
  temperature: number,
  humidity: number,
  windSpeed?: number,
  solarRadiation?: number,
) => {
  if (feelLike === HUMIDEX) {
    return humidex(temperature, humidity);
  } else if (feelLike === HEAT_INDEX) {
    return heatIndex(temperature, humidity);
  }
  return australianFormula(temperature, humidity, windSpeed, solarRadiation);
};
